import React from 'react';
import {InvoiceLog} from '../../types/invoice-log';
import FormattedDate from 'components/formatted-date';
import {TableColumn} from 'react-data-table-component';
import {Trans} from 'react-i18next';
import {ColumnDef} from '@tanstack/table-core';

const columns: ColumnDef<InvoiceLog>[] = [
  {
    header: r => <Trans i18nKey="invoiceLogsTab.logDate" />,
    accessorFn: row => (
      <FormattedDate value={row?.created_at} format="datetime" />
    ),
    id: 'date',
    cell: r => r.getValue(),
    enableSorting: false,
  },
  {
    header: r => <Trans i18nKey="invoiceLogsTab.user" />,
    accessorFn: row => (row.causer ? row.causer?.full_name : '-'),
    id: 'name',
    cell: r => r.getValue(),
    enableSorting: false,
  },
  {
    header: r => <Trans i18nKey="invoiceLogsTab.action" />,
    accessorFn: row => row.description,
    id: 'action',
    cell: r => r.getValue(),
    enableSorting: false,
  },
];

export default columns;
